import React, { ReactNode } from "react";
import { Grid, Box } from "@material-ui/core";
import { Trans } from "react-i18next";
import CompanyHeading from "../../theming/CompanyHeading";

interface CertificateVerificationProps {
  heading: string;
  text?: string;
  children?: ReactNode;
  emoticon?: ReactNode;
}

/**
 * Layout wrapper for certificate verification views.
 *
 * @param heading - Main heading text
 * @param text - Supporting description text
 * @param children - Content to render inside the layout
 * @param emoticon - Optional emoticon or icon to display
 */
export const CertificateVerification: React.FC<CertificateVerificationProps> = ({
  heading,
  text,
  children,
  emoticon,
}) => {
  return (
    <Grid container spacing={3} style={{ padding: "1rem" }}>
      <Grid item xs={12} md={9}>
        <Box>
          <CompanyHeading>
            {" "}
            {emoticon ? `${emoticon} ` : null}
            {heading}
          </CompanyHeading>
          <Trans>{text}</Trans>
        </Box>
      </Grid>
      {children ? (
        <Grid item xs={12} md={9}>
          {children}
        </Grid>
      ) : null}
    </Grid>
  );
};
